import { useState, type ReactElement } from "react";
import { FiCheck, FiCopy } from "react-icons/fi";

interface CopyMarkdownButtonProps {
	markdown: string | null | undefined;
	title?: string | null;
}

export function CopyMarkdownButton({
	markdown,
	title,
}: CopyMarkdownButtonProps): ReactElement | null {
	const [copied, setCopied] = useState(false);

	if (!markdown) return null;

	async function handleCopy() {
		const text = title ? `# ${title}\n\n${markdown}` : markdown!;
		await navigator.clipboard.writeText(text);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	}

	return (
		<button
			type="button"
			onClick={handleCopy}
			className="border-line text-fg-faint hover:border-accent-muted hover:text-accent flex h-8 w-8 items-center justify-center rounded-full border transition-colors"
			title="Copy markdown"
		>
			{copied ? (
				<FiCheck className="text-sm text-green-400" />
			) : (
				<FiCopy className="text-sm" />
			)}
		</button>
	);
}
